import { applyMiddleware, createStore, compose } from 'redux';
import platformDetectorMiddleware from './platformDetectorMiddleware';
import localStorageMiddleware from './localStorageMiddleware';
import chromeStorageMiddleware from './chromeStorageMiddleware';
import queryStringMiddelware from './queryStringMiddleware';
import queryStringParameters from './queryStringParameters';
import reducer from '../reducers/reducer';

let middlewares = [platformDetectorMiddleware, localStorageMiddleware];

// Packaged Chrome app will include a `chromeapp` parameter in the URL.
// We only need to apply the `chromeStorageMiddleware` for the packaged Chrome app.
const appId = queryStringParameters.chromeappid;
if (appId) {
	middlewares.push(chromeStorageMiddleware(appId));
}

// Order matters. Query string parameters should take precedence over local storage
// or Chrome storage, so `queryStringMiddleware` needs to be added last.
middlewares.push(queryStringMiddelware);

const middleware = applyMiddleware(...middlewares);
const enhancers =
	process.env.NODE_ENV !== 'production' && window.devToolsExtension
		? compose(middleware, window.devToolsExtension())
		: middleware;

const reduxStore = createStore(reducer, enhancers);

export default reduxStore;



// WEBPACK FOOTER //
// ./src/services/reduxStore.js